import { parseCookies } from 'nookies';

import { cookies } from '../constants/cookies';

export function getSegmentFromCookies(): string {
  const { [cookies.SEGMENT_ID]: segment } = parseCookies();

  return segment;
}
